import { render, staticRenderFns } from "./liaisonCard.vue?vue&type=template&id=09ce51ce&scoped=true&"
import script from "./liaisonCard.vue?vue&type=script&lang=tsx&"
export * from "./liaisonCard.vue?vue&type=script&lang=tsx&"
import style0 from "./liaisonCard.vue?vue&type=style&index=0&id=09ce51ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce51ce",
  null
  
)

export default component.exports